import { onBrightColorValues, onDarkColorValues } from "../../onColorsSettings";
export var f7f9fbColorValues = {
  color: "#f7f9fb",
  onColor: onBrightColorValues
};
export var fffColorValues = {
  color: "#fff",
  onColor: onBrightColorValues
};
export var ebeff1ColorValues = {
  color: "#ebeff1",
  onColor: onBrightColorValues
};

// eslint-disable-next-line no-underscore-dangle
export var _1b1b1bColorValues = {
  color: "#1b1b1b",
  onColor: onDarkColorValues
};